import React from "react";
import classNames from "classnames";
import { AppImage } from "@/shared/Components";
import styles from "./styles.module.scss";

interface Props {
  src?: string;
}

export const ContactCardAvatar: React.FC<Props> = ({ src }) => {
  return (
    <div className={classNames(styles.wrapper)}>
      <AppImage
        isEditable={false}
        src={src}
        className={classNames(styles["contact-card-image"])}
        preview={false}
      />
    </div>
  );
};
